<div class="cipx-system-tool-card" (click)="onClicked()">
  <div class="flex items-center justify-between">
    <div class="flex flex-row gap-2">
      <mat-icon class="icon-size-5">{{ tool.icon }}</mat-icon>
      <div class="cipx-system-tool-card__title">{{ tool.label }}</div>
    </div>
  </div>
  <div class="cipx-system-tool-card__description" [innerHTML]="tool.tips"></div>
</div>
